module.exports = __webpack_public_path__ + "img/instagram.300f2850.svg";